import React from 'react'
import { Breadcrumb, Card, Icon, Layout, Row } from "antd";
import style from '../Payments/style.css'
import List from './List'
import useTitle from '../../../elements/Hooks/useTitle'
import PageTitle from "../../../elements/PageTitle";

const {Content} = Layout

function Quotes(props) {
  useTitle('Quotes')
  return (
    <>
      <Content style={{margin: '0px 0px'}}>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item>Quotes</Breadcrumb.Item>
          </Breadcrumb>
          <PageTitle
            title={'Quotes'}
            subtitle={'List of Client Quotations.'}
            color={'#52c41a'}
            iconType={'money-collect'}
          />
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <List {...props} />
      </Card>
      </Content>
    </>
  )
}

Quotes.propTypes = {}
Quotes.defaultProps = {}

export default Quotes
